import { ListItemResponse } from "@/web-client/api";
import { CSSProperties, FC, useMemo } from "react";

interface Props {
  listItem: ListItemResponse;
}

const SelectedListItem: FC<Props> = ({ listItem }): JSX.Element => {
  const uploadImage = listItem.upload_image;

  const wrapperStyle = useMemo<CSSProperties>(() => {
    if (!uploadImage) {
      return {
        width: 100,
        background: "#aaa",
      };
    }
    const width = uploadImage.width > uploadImage.height ? 100 : 60;

    return {
      width: `${width}px`,
      backgroundImage: `url(${uploadImage.urls.small})`,
    };
  }, [uploadImage]);

  const spacerStyle = useMemo<CSSProperties>(() => {
    if (!uploadImage) {
      return {
        paddingTop: `56.65%`,
      };
    }
    const padding = uploadImage.height / uploadImage.width;

    return {
      paddingTop: `${padding * 100}%`,
    };
  }, [uploadImage]);

  return (
    <article
      style={wrapperStyle}
      className="relative bg-cover bg-center bg-no-repeat"
    >
      <div style={spacerStyle} />
    </article>
  );
};

export default SelectedListItem;
